import * as React from 'react';
import b_ from 'b_';
import { Money } from 'shared/types/common';
import MoneyView from 'shared/components/MoneyView';

import './index.scss';

interface Props {
  title: string;
  children?: Money | null;
}

const b = b_.with('position-details-fee');

export const Fee: React.SFC<Props> = ({ title, children }) => {
  return (
    <div className={b('row')}>
      <div className={b('column')}>{title}</div>
      <div className={b('column')}>
        <MoneyView cents>{children}</MoneyView>
      </div>
    </div>
  );
};
